import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/frontend/node_modules/.pnpm/next@15.4.7_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/frontend/src/app/globals.css");
